export enum DeclarationStatusEnum {
  Draft = 1,
  Shared = 2,
  Corrected = 3,
  SentByPost = 4
}